import { Container } from "../../UI/container/Container";
import { Grid, LoadingOverlay } from "@mantine/core";
import { BlogData, useBlogList } from "../../../hooks/react-query/useBlogList";
import { Fragment, useState } from "react";
import { useSpecialistList } from "../../../hooks/react-query/useSpecialistList";
import { Post } from "../../../types/graphql";
import useAsyncEffect from "use-async-effect";
import { MyButton } from "../../UI/my-button/MyButton";
import { IconChevronRight } from "@tabler/icons";
import { usePaginationStore } from "../../config/store/usePaginationStore";
import { useColors } from "../../../hooks/colors/useColors";
import { useTranslation } from "next-i18next";
import { BlogCard } from "../homepage/blog/BlogCard";
import { useRouter } from "next/router";
import { Footer } from "../homepage/footer/Footer";
import { BlogCol } from "../homepage/blog/blog-col";

type InputProps = {
  authorBlogs?: Record<string, BlogData>;
};

export function BlogList({ authorBlogs }: InputProps) {
  const { blogs, comparePosts } = useBlogList();
  let allBlogs = blogs;
  if (authorBlogs) allBlogs = authorBlogs;

  return (
    <Fragment>
      <Container noHeight>
        <Grid>
          {
            <Fragment>
              {allBlogs &&
                Object.keys(allBlogs)
                  .sort((a, b) => comparePosts(a, b, allBlogs))
                  .map((key, index) => {
                    // @ts-ignore
                    const blogPost = allBlogs[key];
                    return <BlogCol key={index} id={key} data={blogPost} />;
                  })}
            </Fragment>
          }
        </Grid>
      </Container>
      {/*<Container noHeight>*/}
      {/*  <LoadingOverlay visible={loading} className="!fixed !top-0" />*/}
      {/*  <Grid>*/}
      {/*    {*/}
      {/*      <Fragment>*/}
      {/*        {specialists &&*/}
      {/*          posts &&*/}
      {/*          posts.length > 0 &&*/}
      {/*          posts.map((post: Post) => {*/}
      {/*            return <BlogCard key={post.slug} data={post} />;*/}
      {/*          })}*/}
      {/*      </Fragment>*/}
      {/*    }*/}
      {/*  </Grid>*/}
      {/*  {typeof allBlogs !== "undefined" &&*/}
      {/*    specialists &&*/}
      {/*    allBlogs.data &&*/}
      {/*    allBlogs.data.posts.pageInfo.hasNextPage &&*/}
      {/*    allBlogs.data.posts.pageInfo.endCursor &&*/}
      {/*    typeof prefetchedPosts === "undefined" && (*/}
      {/*      <div className="flex items-center justify-center my-8">*/}
      {/*        <MyButton*/}
      {/*          loading={loading}*/}
      {/*          onClick={() => {*/}
      {/*            setHasNextPage(true);*/}
      {/*            setAfter(allBlogs.data.posts.pageInfo.endCursor?.toString());*/}
      {/*          }}*/}
      {/*          title={*/}
      {/*            <div className="flex items-center">*/}
      {/*              <span>{i18n.t("load-more")}</span>*/}
      {/*              <IconChevronRight />*/}
      {/*            </div>*/}
      {/*          }*/}
      {/*          color={colors.primary}*/}
      {/*        />*/}
      {/*      </div>*/}
      {/*    )}*/}
      {/*</Container>*/}
      <Footer isVisible={typeof allBlogs?.data !== "undefined"} />
    </Fragment>
  );
}
